<template>
    <div class="report-card">
        <div class="report-card-top">
            <slot name="head">
                <div class="flex items-center">
                    <div class="mr-4 h-10 w-10 shrink-0">
                        <slot name="icon"></slot>
                    </div>
                    <div class="report-card-title">
                        <div class="relative">{{ title }}</div>
                    </div>
                </div>
                <slot name="action" />
            </slot>
        </div>

        <template v-if="isError">
            <div class="mt-10 flex h-full w-full flex-col items-center justify-center pb-10">
                <img src="@/assets/images/reload-cat.png" alt="" class="mb-6 h-[140px]" />
                <div class="mb-4 text-center text-sm text-gray-90">{{ errorText }}</div>
                <button v-if="!disableRetry" class="th-btn th-btn-outline th-btn-sm" @click="refresh">
                    {{ t('report.retry') }}
                </button>
            </div>
        </template>
        <slot v-else></slot>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n()

const props = withDefaults(defineProps<{
    title?: string;
    isShowError?: boolean;
    refresh?: () => void;
    disableRetry?: boolean;
}>(), {
    title: 'No Title',
    isShowError: false,
    refresh: () => {
        console.warn('need refresh func');
    },
});

const isError = computed(() => props.isShowError);

const errorText = computed(() => {
    return props.disableRetry ? t('report.oldVersion') : t('report.cardFailed');
});

</script>

<style lang="scss">
.report-card {
    @apply rounded w-full bg-white p-6;
    box-shadow: 0 2px 20px 0 rgba(0, 84, 183, 0.07);
}

.report-card-top {
    @apply flex items-end w-full mb-6 justify-between;
}

.report-card-title {
    @apply h-8 pb-1 relative w-full text-xl leading-6 text-black font-semibold grow;

    &:before {
        content: '';
        @apply absolute bottom-0 left-0 w-full h-[18px];
        background: linear-gradient(90deg, rgba(7, 100, 233, 0.40) 0.05%, rgba(230, 244, 255, 0.00) 98.6%);
    }
}
</style>
